import React from 'react'
import styled from 'styled-components'

import GrayButton from './GrayButton'
import MountainIcon from '~/components/svg/MountainIcon'
import EvidenceModal from './EvidenceModal'

const ButtonText = styled.p`
  margin: 0;
  font-size: 0.75rem;
  color: ${props => props.theme.colors.primary};
`

const AddPictureButton = props => {
  const Icon = () => <MountainIcon color="#3089f3" />
  const OpenButton = ({ onClick }) => (
    <GrayButton
      Svg={Icon}
      onClick={onClick}
      fullHeight
    >
      <ButtonText>Add evidence</ButtonText>
    </GrayButton>
  )

  return (
    <EvidenceModal 
      opener={OpenButton} 
      ticket={props.ticket} 
    />
  )
}

export default AddPictureButton